import React, { ReactElement } from 'react';
import { Text, TextStyle, Pressable, View, ViewStyle } from 'react-native';
import { Icon as RNVIcon } from 'renative';
import Theme from 'Theme';
import Icon from '../Icon';
import defaultStyles from './styles';

interface ButtonProps {
    onPress?: () => void;
    iconName?: string | null;
    title?: string | ReactElement;
    style?: {
        icon?: ViewStyle;
        button?: ViewStyle;
        textContainer?: ViewStyle;
        text?: TextStyle;
        iconContainer?: ViewStyle;
    };
    importedStyle?: ViewStyle;
    isSecondary?: boolean;
    isDropdown?: boolean;
    isToggled?: boolean;
    isDisabled?: boolean;
    ellipsizeMode?: 'tail' | 'middle' | 'head' | 'clip';
    testID?: string;
    activeOpacity?: number;
}

const Button = ({
    onPress,
    iconName = null,
    title = '',
    style,
    isSecondary = false,
    isDropdown = false,
    isToggled = false,
    isDisabled = false,
    ellipsizeMode = 'tail',
    testID,
    activeOpacity = 0.4,
    importedStyle
}: ButtonProps): React.ReactElement => {
    const buttonStyle = importedStyle || [
        defaultStyles.button,
        isSecondary ? defaultStyles.secondaryButtonStyle : {},
        isDropdown ? defaultStyles.textContainerDropdown : {},
        style?.button,
        isDisabled && { opacity: 0.5 }
    ];
    return (
        <Pressable
            disabled={isDisabled}
            onPress={onPress}
            testID={testID}
            style={({ pressed }) => [
                {
                    backgroundColor: 'gray',
                    opacity: pressed ? activeOpacity : 1,
                },
                buttonStyle
            ]}
        >
            {iconName && (
                <View style={defaultStyles.iconContainer}>
                    <Icon name={iconName} style={[defaultStyles.icon, style?.icon]} />
                </View>
            )}
            <View
                style={[
                    iconName ? defaultStyles.textContainer : defaultStyles.textContainerWithoutIcon,
                    style?.textContainer
                ]}
            >
                <Text
                    numberOfLines={1}
                    ellipsizeMode={ellipsizeMode}
                    style={[defaultStyles.text, style?.text]}
                    adjustsFontSizeToFit
                >
                    {title}
                </Text>
            </View>
            {isDropdown && (
                <View style={[defaultStyles.iconContainer, style?.iconContainer]}>
                    <RNVIcon
                        iconFont="fontAwesome"
                        iconName={isToggled ? 'caret-up' : 'caret-down'}
                        iconColor={isToggled ? Theme.lightThemeTextColor : Theme.primaryTextColor}
                        style={{
                            ...defaultStyles.icon,
                            ...style?.icon
                        }}
                        onPress={onPress}
                    />
                </View>
            )}
        </Pressable>
    );
};

export default Button;
